import { useState } from 'react';
import { COMPANY_INFO } from '../data/staticData';
import ContactForm from '../components/ContactForm';

export default function JobsPage() {
  const [activeTab, setActiveTab] = useState('Alle');
  const [expandedJob, setExpandedJob] = useState(null);

  const jobs = [
    {
      id: 'toemrere',
      region: 'Jylland',
      title: 'Tømrere søges til Østjylland',
      intro: 'Vi har dejligt travlt og søger tømrere til opstart hurtigst muligt. Du vil komme til at arbejde primært med tagopgaver som tegltage, betontage, ståltage og eternittage. Vi arbejder også med opgaver som indblæsning af isolering af loft og montering af vinduer osv.',
      where: 'Arbejdet vil primært foregå i Århus, Randers, Silkeborg, Skanderborg og Horsens.',
      who: 'Du skal være uddannet tømrer, have min. 1-3 års erfaring inden for faget, kunne tænke selvstændigt og have god håndværksmæssig forståelse. Derudover er du kundeminded og har kørekort.',
      offer: [
        'Et spændende job med frihed under ansvar',
        'At blive en del af et godt team med faglig sparring',
        'Firmabil, da du kører ud fra din privatadresse',
        'God løn samt diæter og bonusordning',
        'Optimale forhold til værktøj, arbejdstøj etc.',
        'Typiske opgaver 1-3 uger samme sted',
        'Mulighed for 4 dages uge efter aftale med din makker/sjakket.'
      ],
      image: 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/imgi-8-thumb.jpg'
    },
    {
      id: 'arbejdsmand',
      region: 'Jylland',
      title: 'Arbejdsmand søges til Østjylland',
      intro: 'Vi har dejligt travlt og søger derfor arbejdsmænd til opstart hurtigst muligt. Du vil komme til at arbejde primært med tagopgaver som tegltage, betontage, ståltage og eternittage. Vi arbejder også med opgaver som indblæsning af isolering af loft og montering af vinduer osv.',
      where: 'Arbejdet vil primært foregå i Århus, Randers, Silkeborg, Skanderborg og Horsens.',
      who: 'Du skal kunne bruge håndværktøj, have min. 1-3 års erfaring inden for faget, kunne tænke selvstændigt og have god håndværksmæssig forståelse. Derudover er du kundeminded og har kørekort.',
      offer: [
        'Et spændende job med frihed under ansvar',
        'At blive en del af et godt team med faglig sparring',
        'Firmabil, da du kører ud fra din privatadresse',
        'God løn samt diæter og bonusordning',
        'Optimale forhold til værktøj, arbejdstøj etc.',
        'Typiske opgaver 1-3 uger samme sted',
        'Mulighed for 4 dages uge efter aftale med din makker/sjakket.'
      ],
      image: 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/scraped-4.webp'
    }
  ];

  const filteredJobs = jobs.filter(
    (job) => activeTab === 'Alle' || job.region === activeTab
  );

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16 lg:pt-20 pb-12 sm:pb-16 border-b border-stone-200">
        <div className="max-w-4xl space-y-6">
          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold text-stone-900 tracking-tight uppercase">
            Vi er altid på udkig efter dygtige håndværkere
          </h1>
          <div className="space-y-4 text-stone-700 text-base sm:text-lg leading-relaxed">
            <p>
              Kunne du tænke dig at blive en del af vores unge team og være med til at udvikle en virksomhed i vækst, der kører rundt i hele Danmark?
            </p>
            <p>
              Se vores ledige stillinger her på siden eller søg uopfordret på{' '}
              <a href="mailto:kontakt@dansktagbyg.dk" className="text-[#BE0F12] font-semibold hover:underline">
                kontakt@dansktagbyg.dk
              </a>{' '}
              eller tlf.{' '}
              <a href="tel:31393411" className="text-[#BE0F12] font-semibold hover:underline">
                31 39 34 11
              </a>
              , hvis vi skal høre mere om dig.
            </p>
          </div>

          {/* Region Tabs */}
          <div className="flex gap-2 pt-4">
            {['Alle', 'Jylland', 'Sjælland'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-6 py-2.5 font-bold text-sm uppercase tracking-wider transition-colors ${
                  activeTab === tab
                    ? 'bg-[#BE0F12] text-white'
                    : 'bg-stone-100 text-stone-700 hover:bg-stone-200'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Jobs Listings */}
      <section className="py-16 sm:py-20 bg-stone-50 border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {filteredJobs.length === 0 ? (
            <div className="text-center py-12 text-stone-500">
              <p>Der er i øjeblikket ingen opslåede stillinger i den valgte region.</p>
              <p className="mt-2 text-sm">Du er altid velkommen til at sende os en uopfordret ansøgning.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
              {filteredJobs.map((job) => {
                const isExpanded = expandedJob === job.id;
                return (
                  <div
                    key={job.id}
                    className="bg-white border border-stone-200 overflow-hidden shadow-sm flex flex-col justify-between"
                  >
                    <div className="h-56 bg-stone-100 overflow-hidden">
                      <img
                        src={job.image}
                        alt={job.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="p-6 sm:p-8 space-y-4">
                      <span className="text-xs font-bold uppercase tracking-widest text-[#BE0F12]">
                        {job.region}
                      </span>
                      <h2 className="text-2xl font-extrabold text-stone-900 uppercase">
                        {job.title}
                      </h2>
                      <p className="text-stone-700 text-sm leading-relaxed">
                        {job.intro}
                      </p>

                      {isExpanded && (
                        <div className="space-y-4 pt-4 border-t border-stone-200 text-stone-700 text-sm leading-relaxed">
                          <div>
                            <h3 className="font-bold text-stone-900 uppercase text-xs tracking-wider mb-1">
                              Hvor?
                            </h3>
                            <p>{job.where}</p>
                          </div>
                          <div>
                            <h3 className="font-bold text-stone-900 uppercase text-xs tracking-wider mb-1">
                              Hvem?
                            </h3>
                            <p>{job.who}</p>
                          </div>
                          <div>
                            <h3 className="font-bold text-stone-900 uppercase text-xs tracking-wider mb-2">
                              Vi tilbyder:
                            </h3>
                            <ul className="space-y-1.5 list-disc list-inside text-xs">
                              {job.offer.map((item, i) => (
                                <li key={i}>{item}</li>
                              ))}
                            </ul>
                          </div>
                          <div className="p-4 bg-stone-50 border border-stone-200 text-xs">
                            <p>
                              Lyder det som noget for dig, kan du søge jobbet på{' '}
                              <a href="mailto:kontakt@dansktagbyg.dk" className="text-[#BE0F12] font-bold underline">
                                kontakt@dansktagbyg.dk
                              </a>{' '}
                              eller ved at ringe til Lasse Vesterhouen på{' '}
                              <a href="tel:31393411" className="text-[#BE0F12] font-bold underline">
                                31393411
                              </a>.
                            </p>
                            <p className="font-semibold text-stone-900 mt-1">Vi glæder os til at høre fra dig!</p>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="p-6 sm:p-8 pt-0">
                      <button
                        onClick={() => setExpandedJob(isExpanded ? null : job.id)}
                        className="px-6 py-2.5 bg-stone-900 hover:bg-black text-white font-bold text-xs uppercase tracking-wider transition-colors"
                      >
                        {isExpanded ? 'Luk' : 'Læs om jobbet'}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* Kontakt os og få den rette rådgivning */}
      <section className="py-12 bg-white text-center border-b border-stone-200">
        <div className="max-w-4xl mx-auto px-4 space-y-4">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 uppercase">
            Kontakt os og få den rette rådgivning
          </h2>
          <div>
            <a
              href="#kontakt"
              className="inline-block px-8 py-3.5 bg-[#BE0F12] hover:bg-[#a00d0f] text-white font-bold text-sm tracking-wider uppercase transition-colors"
            >
              Kontakt os
            </a>
          </div>
        </div>
      </section>

      {/* Bund: Anmeldelser og Kontaktformular (som på originalen) */}
      <section id="kontakt" className="py-16 sm:py-24 bg-stone-100 scroll-mt-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 sm:gap-16 items-start">
            
            {/* Venstre kolonne: Firmaoplysninger og Anmeld Håndværker */}
            <div className="lg:col-span-5 space-y-8">
              <div className="p-6 bg-white border border-stone-200 shadow-sm space-y-3">
                <div className="flex items-center gap-1 text-amber-500 text-lg">
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                </div>
                <a
                  href="https://www.anmeld-haandvaerker.dk/tagdaekker/dansk-tagbyg-aps"
                  target="_blank"
                  rel="noreferrer"
                  className="block font-black text-xl text-stone-900 hover:text-[#BE0F12] transition-colors"
                >
                  4,8 ud af 155 anmeldelser
                </a>
                <p className="text-xs text-stone-500">
                  Finalist til Årets Håndværker 5 år i træk
                </p>
              </div>

              <div className="p-6 bg-white border border-stone-200 shadow-sm space-y-4 text-sm text-stone-700">
                <h3 className="font-extrabold text-xl text-stone-900 uppercase">
                  Dansk Tagbyg ApS
                </h3>
                <div className="space-y-2">
                  <p>
                    <strong className="text-stone-900">Ring:</strong>{' '}
                    <a href={`tel:${COMPANY_INFO.phone}`} className="text-[#BE0F12] font-bold hover:underline">
                      {COMPANY_INFO.phoneFormatted}
                    </a>
                  </p>
                  <p>
                    <strong className="text-stone-900">Skriv:</strong>{' '}
                    <a href={`mailto:${COMPANY_INFO.email}`} className="text-[#BE0F12] font-bold hover:underline">
                      {COMPANY_INFO.email}
                    </a>
                  </p>
                  <p>
                    <strong className="text-stone-900">Adr:</strong> {COMPANY_INFO.address}
                  </p>
                  <p>
                    <strong className="text-stone-900">CVR:</strong> {COMPANY_INFO.cvr}
                  </p>
                </div>
                <div className="pt-3 border-t border-stone-200">
                  <p className="font-bold text-stone-900">Vi løser opgaver i hele DK</p>
                </div>
                <div className="pt-2">
                  <p className="text-xs font-bold text-stone-500 uppercase tracking-wider mb-2">Vi er medlem af</p>
                  <div className="flex flex-wrap gap-2 text-xs font-semibold text-stone-700">
                    <span className="px-2.5 py-1 bg-stone-100 border border-stone-200">Swisspearl</span>
                    <span className="px-2.5 py-1 bg-stone-100 border border-stone-200">Byg Garanti</span>
                    <span className="px-2.5 py-1 bg-stone-100 border border-stone-200">DI Byggeri</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Højre kolonne: Kontaktformular */}
            <div className="lg:col-span-7 bg-white border border-stone-200 p-8 sm:p-10 shadow-sm">
              <ContactForm idPrefix="jobs" submitButtonText="Send" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
